export var AccountState;
(function (AccountState) {
    /** Default state. User can login and use his account normally. */
    AccountState["Active"] = "active";
    /** User can't login and use his account, but his account still exists for other users.  */
    AccountState["Inactive"] = "inactive";
    /** Soft delete state. */
    AccountState["Archived"] = "archived";
})(AccountState || (AccountState = {}));
